import '../App.css';
import { Link } from 'react-router-dom';
import Layout from "../components/Layout";

const MONKEY_PORTRAIT = "https://i.redd.it/dkrdh85bm4sb1.png";

function Home() {
    return (
        <Layout>
            <section className="hero">
                <div className="hero-copy anim-pop">
                    <h1 className="display-title">Top&nbsp;Monkey</h1>
                    <p className="tagline">
                        What the horse considers play, the monkey considers business.
                        Swing through math problems and stack up bananas!
                    </p>
                    <div className="btn-row">
                        <Link className="btn btn-xl" to="/play">🍌 Start Playing</Link>
                        <Link className="btn btn-leaf" to="/practice">Practice</Link>
                    </div>
                </div>

                <div className="monkey-stage">
                    <span className="vine-rope" />
                    <div className="monkey-ring">
                        <span className="monkey-leaf monkey-leaf-left" />
                        <span className="monkey-leaf monkey-leaf-right" />
                        <div className="monkey-frame">
                            <img
                                className="monkey-img"
                                src={MONKEY_PORTRAIT}
                                alt="The Top Monkey mascot"
                                referrerPolicy="no-referrer"
                            />
                        </div>
                        <span className="badge badge-banana monkey-caption">Top Banana</span>
                    </div>
                </div>
            </section>

            <div className="leaf-divider">🌿 🍌 🌿</div>

            <nav className="menu-grid">
                <Link className="menu-card menu-play" to="/play">
                    <span className="menu-icon">🎯</span>
                    <span className="menu-title">Play</span>
                    <p className="menu-sub">Beat the clock for a high score</p>
                </Link>
                <Link className="menu-card menu-practice" to="/practice">
                    <span className="menu-icon">🌱</span>
                    <span className="menu-title">Practice</span>
                    <p className="menu-sub">Warm up those monkey brains</p>
                </Link>
                <Link className="menu-card menu-login" to="/login">
                    <span className="menu-icon">🐵</span>
                    <span className="menu-title">Login</span>
                    <p className="menu-sub">Claim your spot in the troop</p>
                </Link>
                <Link className="menu-card menu-leaderboard" to="/leaderboard">
                    <span className="menu-icon">🏆</span>
                    <span className="menu-title">Leaderboard</span>
                    <p className="menu-sub">See who rules the canopy</p>
                </Link>
            </nav>
        </Layout>
    );
}

export default Home;
